import { GetWeeklyOpenSlotsResponse } from "@/pages/multishop-selection/responses";
import axios from "axios"

export type FetchWeeklyOpenSlotsParams = {
  startDate: string;
  endDate: string;
  shopId?: number;
  shopIds?: number[];
};

export const fetchWeeklyOpenSlots = ({
  startDate,
  endDate,
  shopId,
  shopIds = [],
}: FetchWeeklyOpenSlotsParams): Promise<GetWeeklyOpenSlotsResponse> => {
  return axios
    .get<GetWeeklyOpenSlotsResponse>("/api/planner/shops/open-slots/weekly", {
      params: {
        startDate,
        endDate,
        shopId,
        shopIds: shopIds.join(','),
      },
    })
    .then((res) => res.data);
};
export const getDailyOpenSlots = (slotDate) => {
  return axios.get('/api/planner/shops/open-slots/daily', {
    params: { slotDate }
  })
    .then(res => res.data);
}


// export const updateDailyOpenSlot = ({
//   slotDate,
//   roomId,
//   startMinuteOfDay,
//   slotStatus
// }) => {
//   return axios.patch('/api/planner/open-slots/status', {
//     slotDate,
//     roomId,
//     startMinuteOfDay,
//     slotStatus
//   })
//     .then(res => res.data)
// }

export const getCalendarOpenSlots = (startDate, endDate) => {
  return axios.get('/api/planner/shops/open-slots/calendar', {
    params: {
      startDate,
      endDate,
    }
  }).then(res => res.data);
}


